import { Link } from 'react-router-dom';
import { hotRank, timeSlots } from '@/mocks/feed';
import HeatMeter from '@/components/base/HeatMeter';

export default function FeedSidebar() {
  return (
    <aside className="flex flex-col gap-6 lg:sticky lg:top-24">
      <div className="rounded-lg border border-background-200/70 bg-background-100/50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-primary-400" />
          夜间热榜
        </h2>
        <ol className="mt-4 space-y-3">
          {hotRank.slice(0, 5).map((item, index) => (
            <li key={item.slug}>
              <Link to={`/article/${item.slug}`} className="group flex items-start gap-3">
                <span
                  className={`font-display text-lg leading-none tracking-wide ${
                    index === 0 ? 'text-primary-400' : index < 3 ? 'text-accent-400' : 'text-foreground-500'
                  }`}
                >
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-300">
                    {item.title}
                  </span>
                  <span className="mt-2 flex">
                    <HeatMeter value={item.heat} tag={item.tag} />
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200/70 bg-background-100/50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-timer-line text-accent-400" />
          按时段直达
        </h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {timeSlots.map((slot) => (
            <Link
              key={slot.key}
              to={`/feed?slot=${encodeURIComponent(slot.key)}`}
              className="rounded-full border border-background-200 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-500/50 hover:text-accent-300"
            >
              {slot.key}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-primary-500/30 bg-primary-500/10 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">熬不动就先放下手机</h2>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          订阅之后，早上八点会收到一封整理好的邮件。夜里的变动，白天再看也不迟。
        </p>
        <Link
          to="/#subscribe"
          className="mt-4 inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 font-label text-sm text-white transition-colors hover:bg-primary-600"
        >
          <i className="ri-mail-send-line" />
          深夜订阅
        </Link>
      </div>
    </aside>
  );
}